import React, { useEffect } from 'react';
import { Button } from 'components'
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const DataTerms2 = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding">
					<div className={styles["count-group"]}>
						<p>전송요구 및 정보 제공 동의</p>
						<div><span>3</span>/3</div>
					</div>
					<div className={`${styles["terms-area"]} mt_40`}>
						<p>개인(신용)정보 제공 동의서</p>
						<span className="mt_10">
							귀하는 개인(신용)정보 제공에 관한 동의를 거부하실 수 있습니다. 다만, 개인(신용) 정보의 제공에 관한 동의는 본인신용정보 통합조회, 데이터분석 서비스, 마이데이터 서비스 가입현황 안내 및 전송요구내역 통합조회 서비스 이용과 직접적으로 관련된 필수적 사항이므로 아래의 사항에 동의하셔야만 본인신용정보 통합조회, 데이터분석 서비스, 마이데이터서비스 가입현황 안내 및 전송요구내역 통합조회 서비스의 제공이 가능합니다.
						</span>
						<ul className="mt_40">
							<li>
								<div>제공받는 자</div>
								<p className="text-blue mt_10">[정보제공자명] KB국민은행, 신한카드, 기업은행, 광주은행, 키움증권, 페이코, 삼성화재, 메리츠화재, 한국투자증권, SC제일은행</p>
							</li>
							<li>
								<div>제공받는 자의 이용목적</div>
								<p className="text-blue mt_10">본인확인 및 개인(신용)정보의 전송</p>
							</li>
							<li>
								<div>보유 및 이용기간</div>
								<p className="text-blue mt_10">본인확인 및 개인(신용)정보의 전송 목적 달성 시까지</p>
							</li>
							<li>
								<div>제공항목</div>
								<span>
									전자서명, CI, 인증서, 전송요구서
								</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div className="padding">
				<div className={`${styles["terms-area"]} pb_100`}>
					<ul>
						<li>
							<div>제공받는 자</div>
							<p className="text-blue mt_10">한국신용정보원</p>
						</li>
						<li>
							<div>제공받는 자의 이용목적</div>
							<p className="text-blue mt_10">마이데이터서비스 가입현황 안내 및 전송요구내역 통합조회 서비스 제공</p>
						</li>
						<li>
							<div>보유 및 이용기간</div>
							<p className="text-blue mt_10">한국신용정보원의 마이데이터서비스 가입현황 안내 및 전송요구내역 통합조회 서비스 목적 달성 시까지</p>
						</li>
						<li>
							<div>제공항목</div>
							<span>회원 가입여부, 서비스목록수, 서비스목록, 클라이언트ID, 전송요구내역수, 전송요구내역목록, 정보제공자 기관코드, 권한 범위, 전송요구일자, 전송요구종료시점</span>
						</li>
					</ul>
					<p className="mt_40">위 개인(신용)정보 제공에 동의하십니까?</p>
				</div>
			</div>
			{/* 스크롤 끝 까지 내려가면 가이드 텍스트 사라지고 버튼명 동의하기로 변경 */}
			<div className={`${styles["floating-btn"]} padding`}>
				<div className="flex-justify_center mb_20">
					<span className={styles.guide}><i className="icon icon_floating_arrow_down mr_5" />끝까지 확인하고 동의하기</span>
				</div>
				<Button className="btn btn--big">아래로 내려보기</Button>
			</div>
		</div>
	)
}

export default DataTerms2